// extracted by mini-css-extract-plugin
export default {"map":"styles_map__H6mJZ","inner":"styles_inner__0bKQf"};